import { render, staticRenderFns } from "./ReportP32ViewSidebar.vue?vue&type=template&id=ebb55640&scoped=true&"
import script from "./ReportP32ViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ReportP32ViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ReportP32ViewSidebar.vue?vue&type=style&index=0&id=ebb55640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb55640",
  null
  
)

export default component.exports